import { c as _c } from "react/compiler-runtime";
import type { ElementType } from 'react';
import type { ClassNameValue } from 'tailwind-merge';
export default function AuthFormIcon(t0) {
  const $ = _c(4);
  const {
    icon: Icon,
    size,
    className
  } = t0;
  let t1;
  if ($[0] !== Icon || $[1] !== className || $[2] !== size) {
    t1 = <Icon className={className} size={size} />;
    $[0] = Icon;
    $[1] = className;
    $[2] = size;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}